import { NgxLoggerLevel } from 'ngx-logger';

export const environment = {
    production: true,
    version: "v5.0.0",
    environmentName: "dev",
    onlyDownloads: false,
    logger: {
        level: NgxLoggerLevel.DEBUG,
        serverLoggingUrl: null,
        serverLogLevel: NgxLoggerLevel.OFF
    },
    firebase: {
        apiKey: "AIzaSyDMmqISyiiWwgugYZ7XdJCSQL65W0unfbk",
        authDomain: "vsight-remote-angular-dev.firebaseapp.com",
        databaseURL: "https://vsight-remote-angular-dev-4d310.europe-west1.firebasedatabase.app/",
        projectId: "vsight-remote-angular-dev",
        storageBucket: "hangaarlab-remote",
        messagingSenderId: "848344207337"
    },
    firebaseLogin: {
        signInWithPassword: "https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyDMmqISyiiWwgugYZ7XdJCSQL65W0unfbk"
    },
    demoWorkflow: {
        howto: {
            sourceAccountId: "-MumH8z6yuc_w9BQ5MqP",
            sourceWorkflowId: "jr8rwCV7wQuOR2j6IHWk"
        },
        maintenance: {
            sourceAccountId: "-MumH8z6yuc_w9BQ5MqP",
            sourceWorkflowId: "jr8rwCV7wQuOR2j6IHWk"
        }
    },
    endPoints: {
        consolelogin: "https://hangaarlab-dev.vsight.io/api/consolelogin",
        createaccount: "https://hangaarlab-dev.vsight.io/api/createaccount",
        createaccountpdf: "https://hangaarlab-dev.vsight.io/api/createaccountpdf",
        updateaccount: "https://hangaarlab-dev.vsight.io/api/updateaccount",
        deleteaccount: "https://hangaarlab-dev.vsight.io/api/deleteaccount",
        toggleaccount: "https://hangaarlab-dev.vsight.io/api/toggleaccount",
        wipeaccount: "https://hangaarlab-dev.vsight.io/api/wipeaccount",
        changethirdparty: "https://hangaarlab-dev.vsight.io/api/changethirdparty",
        sendusage: "https://hangaarlab-dev.vsight.io/api/sendusage",
        exportsession: "https://hangaarlab-dev.vsight.io/api/exportsession",
        featureupdates: "https://hangaarlab-dev.vsight.io/api/featureupdates",
        copyDemoWorkflow: "https://hangaarlab-dev.vsight.io/api/copyDemoWorkflow",
        getManagerReport: "https://hangaarlab-dev.vsight.io/api/getManagerReport",
        applyRemoteForceUpdate: "https://hangaarlab-dev.vsight.io/api/applyRemoteForceUpdate",
        importusers: "https://hangaarlab-dev.vsight.io/api/importusers",
        importusersconfirm: "https://hangaarlab-dev.vsight.io/api/importusersconfirm",
        createClaroRooms: "https://hangaarlab-dev.vsight.io/api/createClaroRooms",
        getUsageStats: "https://hangaarlab-dev.vsight.io/api/getUsageStats",
        getSessionRatings: "https://hangaarlab-dev.vsight.io/api/getSessionRatings",
        getAllWorkflows: "https://hangaarlab-dev.vsight.io/api/getAllWorkflows",
    }
};